import {BaseEventTrackerWrapper, EventName, ExtraData} from './trackers/BaseEventTrackerWrapper';
import { NullEventTracker } from './trackers/empty';
import {GoogleAnalyticsEventTracker} from './trackers/gtag';

export interface CommonEventData {
    framework_version: string;
    game_family: string;
    game_id: string;
    game_name: string;
    game_version: string;
}

export class EventTracker {
    private tracker: BaseEventTrackerWrapper;

    private rate = window.RP_CONFIG?.analytics_activation || 0;

    constructor(private readonly commonData: CommonEventData) {
        const constructor = this.getEventTracker();

        this.tracker = new constructor();
        this.tracker.init();
    }

    public tag(event: EventName, extraData: ExtraData = {}): void {
        this.tracker.tag(event, {...extraData, ...this.commonData});
    }

    private getEventTracker(): new () => BaseEventTrackerWrapper {
        if (Math.random() > this.rate) {
            return NullEventTracker;
        }

        return GoogleAnalyticsEventTracker;
    }
}
